// extracted by mini-css-extract-plugin
export default {"btn":"deleteButton_btn__PEG3K"};